import { render } from "./ManageDatasetAccess.vue?vue&type=template&id=9861600c&scoped=true"
import script from "./ManageDatasetAccess.vue?vue&type=script&lang=js"
export * from "./ManageDatasetAccess.vue?vue&type=script&lang=js"

import "./ManageDatasetAccess.vue?vue&type=style&index=0&id=9861600c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9861600c"]])

export default __exports__